import React, { useContext, useState } from "react";
import toastMessage from "./ToastMessage";
import { AppSettings } from "../config/app-settings";
import apiClient from "../ApiClient";
import { Swiper, SwiperSlide } from "swiper/react";
import Fancybox from "./Fancybox";
import { Pagination } from "swiper/modules";
import "swiper/css/pagination";

export default function DynamicImagesCard({
  fancyboxID,
  images,
  setImages,
  upload = false,
}) {
  const context = useContext(AppSettings);

  const [customerSwiper, setCustomerSwiper] = useState(null);

  const handleUpload = async (e) => {
    const maxFileSize = 5 * 1024 * 1024;

    if (e.size > maxFileSize) {
      toastMessage(context?.t?.max_file_size_5mb, "error");
      return;
    }

    const formData = new FormData();
    formData.append("file", e);

    try {
      const response = await apiClient.post("/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response) {
        setImages((prevImages) => [...prevImages, response.data.url]);
      }
    } catch (error) {
      console.error("Upload File Error", error);
    }
  };

  const handleRemove = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  return (
    <div className="flex-1 d-flex flex-col h-100">
      {upload && (
        <div className="mb-3">
          <input
            id={"create_graphic_upload_image"}
            type="file"
            accept=".png, .jpg, .jpeg"
            className="d-none"
            onChange={(e) => handleUpload(e.target.files[0])}
          />
          <label
            htmlFor={"create_graphic_upload_image"}
            className="btn btn-outline-theme w-100 h-100 d-flex align-items-center justify-content-center pointer"
          >
            Görsel Yükle
          </label>
        </div>
      )}

      <div className="flex-1 overflow-hidden">
        <Fancybox
          className="h-100"
          options={{
            Carousel: {
              infinite: false,
            },
          }}
        >
          <div className="d-flex gap-2 align-items-center h-100">
            <button
              className="btn py-0 px-2 text-black btn-theme"
              onClick={() => customerSwiper.slidePrev()}
            >
              <i className="fas fa-angle-left"></i>
            </button>

            <div className="flex-1 overflow-hidden h-100">
              <Swiper
                onSwiper={(s) => {
                  setCustomerSwiper(s);
                }}
                loop={false}
                slidesPerView={1}
                spaceBetween={24}
                pagination={{
                  type: "fraction",
                }}
                modules={[Pagination]}
                className="h-100 pb-5"
              >
                {images.map((img, index) => (
                  <SwiperSlide key={index}>
                    <a
                      href={img}
                      data-fancybox={fancyboxID}
                      className="d-block border rounded overflow-hidden position-relative h-100"
                    >
                      {upload && (
                        <button
                          className="btn btn-danger position-absolute top-0 end-0"
                          onClick={() => handleRemove(index)}
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      )}
                      <img
                        src={img}
                        alt={`Uploaded ${index}`}
                        className="w-100 h-100"
                        height={200}
                        style={{
                          objectFit: "cover",
                        }}
                      />
                    </a>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <button
              className="btn py-0 px-2 text-black btn-theme"
              onClick={() => customerSwiper.slideNext()}
            >
              <i className="fas fa-angle-right"></i>
            </button>
          </div>
        </Fancybox>
      </div>
    </div>
  );
}
